/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/userProfileOperationsMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a UserProfileOperations. */
export class UserProfileOperations {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a UserProfileOperations.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls Graph APIs to return the user's profile information.
   * @summary Retrieves the current user's profile information
   * @param [options] The optional parameters
   * @returns Promise<Models.UserProfileGetUserProfileResponse>
   */
  getUserProfile(options?: coreHttp.RequestOptionsBase): Promise<Models.UserProfileGetUserProfileResponse>;
  /**
   * @param callback The callback
   */
  getUserProfile(callback: coreHttp.ServiceCallback<Models.UserProfile>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getUserProfile(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserProfile>): void;
  getUserProfile(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserProfile>, callback?: coreHttp.ServiceCallback<Models.UserProfile>): Promise<Models.UserProfileGetUserProfileResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getUserProfileOperationSpec,
      callback) as Promise<Models.UserProfileGetUserProfileResponse>;
  }

  /**
   * Patch states in user profile. Currently, only the dismiss state for the Clarity privacy notice
   * is supported.
   * @summary Patch states in user profile
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  patchUserProfile(options?: Models.UserProfilePatchUserProfileOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  patchUserProfile(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  patchUserProfile(options: Models.UserProfilePatchUserProfileOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  patchUserProfile(options?: Models.UserProfilePatchUserProfileOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      patchUserProfileOperationSpec,
      callback);
  }

  /**
   * Calls Graph APIs to return the metadata of the user's profile photo.
   * @summary Retrieves the metadata of the current user's profile photo.
   * @param [options] The optional parameters
   * @returns Promise<Models.UserProfileGetUserProfilePhotoMetadataResponse>
   */
  getUserProfilePhotoMetadata(options?: coreHttp.RequestOptionsBase): Promise<Models.UserProfileGetUserProfilePhotoMetadataResponse>;
  /**
   * @param callback The callback
   */
  getUserProfilePhotoMetadata(callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getUserProfilePhotoMetadata(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  getUserProfilePhotoMetadata(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>, callback?: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): Promise<Models.UserProfileGetUserProfilePhotoMetadataResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getUserProfilePhotoMetadataOperationSpec,
      callback) as Promise<Models.UserProfileGetUserProfilePhotoMetadataResponse>;
  }

  /**
   * Calls Graph APIs to return the metadata of the user's profile photo for a given size.
   * @summary Retrieves the metadata of the current user's profile photo for a given size.
   * @param photoSizeId
   * @param [options] The optional parameters
   * @returns Promise<Models.UserProfileGetUserProfilePhotoMetadataForSizeIdResponse>
   */
  getUserProfilePhotoMetadataForSizeId(photoSizeId: string, options?: coreHttp.RequestOptionsBase): Promise<Models.UserProfileGetUserProfilePhotoMetadataForSizeIdResponse>;
  /**
   * @param photoSizeId
   * @param callback The callback
   */
  getUserProfilePhotoMetadataForSizeId(photoSizeId: string, callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  /**
   * @param photoSizeId
   * @param options The optional parameters
   * @param callback The callback
   */
  getUserProfilePhotoMetadataForSizeId(photoSizeId: string, options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): void;
  getUserProfilePhotoMetadataForSizeId(photoSizeId: string, options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>, callback?: coreHttp.ServiceCallback<Models.UserProfilePhotoMetadata>): Promise<Models.UserProfileGetUserProfilePhotoMetadataForSizeIdResponse> {
    return this.client.sendOperationRequest(
      {
        photoSizeId,
        options
      },
      getUserProfilePhotoMetadataForSizeIdOperationSpec,
      callback) as Promise<Models.UserProfileGetUserProfilePhotoMetadataForSizeIdResponse>;
  }

  /**
   * Gets auth token cookie from header for WebView
   * @summary Gets auth token cookie from header for WebView
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  getAuthCookie(options?: coreHttp.RequestOptionsBase): Promise<coreHttp.RestResponse>;
  /**
   * @param callback The callback
   */
  getAuthCookie(callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getAuthCookie(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<void>): void;
  getAuthCookie(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getAuthCookieOperationSpec,
      callback);
  }

  /**
   * Calls IDSAPI APIs to return the date of birth and the age group of the user.
   * @summary Retrieves the age details of the current.
   * @param [options] The optional parameters
   * @returns Promise<Models.UserProfileGetUserAgeDetailsResponse>
   */
  getUserAgeDetails(options?: coreHttp.RequestOptionsBase): Promise<Models.UserProfileGetUserAgeDetailsResponse>;
  /**
   * @param callback The callback
   */
  getUserAgeDetails(callback: coreHttp.ServiceCallback<Models.UserAgeDetails>): void;
  /**
   * @param options The optional parameters
   * @param callback The callback
   */
  getUserAgeDetails(options: coreHttp.RequestOptionsBase, callback: coreHttp.ServiceCallback<Models.UserAgeDetails>): void;
  getUserAgeDetails(options?: coreHttp.RequestOptionsBase | coreHttp.ServiceCallback<Models.UserAgeDetails>, callback?: coreHttp.ServiceCallback<Models.UserAgeDetails>): Promise<Models.UserProfileGetUserAgeDetailsResponse> {
    return this.client.sendOperationRequest(
      {
        options
      },
      getUserAgeDetailsOperationSpec,
      callback) as Promise<Models.UserProfileGetUserAgeDetailsResponse>;
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const getUserProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me",
  responses: {
    200: {
      bodyMapper: Mappers.UserProfile
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const patchUserProfileOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "PATCH",
  path: "api/v1/me",
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.UserProfilePatchRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getUserProfilePhotoMetadataOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/photo",
  responses: {
    200: {
      bodyMapper: Mappers.UserProfilePhotoMetadata
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getUserProfilePhotoMetadataForSizeIdOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/photos/{photoSizeId}",
  urlParameters: [
    Parameters.photoSizeId
  ],
  responses: {
    200: {
      bodyMapper: Mappers.UserProfilePhotoMetadata
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getAuthCookieOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/token",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const getUserAgeDetailsOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "GET",
  path: "api/v1/me/ageDetails",
  responses: {
    200: {
      bodyMapper: Mappers.UserAgeDetails
    },
    404: {
      bodyMapper: Mappers.UserAgeDetails
    },
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
